import { execOnLoad, getCssVariable } from '@general/helpers';
import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';
import { throttle } from 'lodash';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initCarousel = (context) => {
  const snippetContainer = context.classList.contains('carousel__container')
    ? context
    : context.closest('.carousel__container');
  if (!snippetContainer) return;

  const sliderWrapper = snippetContainer.querySelector('.carousel__slider-wrapper');
  const slides = snippetContainer.querySelectorAll('.swiper-slide');
  if (!sliderWrapper || slides.length <= 1) return;

  const leftArrow = snippetContainer.querySelector('.carousel__arrow--left');
  const rightArrow = snippetContainer.querySelector('.carousel__arrow--right');
  const scrollbar = snippetContainer.querySelector('.carousel__scrollbar');
  const options = {
    modules: [...(leftArrow && rightArrow ? [Navigation] : []), ...(scrollbar ? [Scrollbar] : [])],
    ...(scrollbar ? { scrollbar: { el: scrollbar, draggable: true } } : {}),
    ...(leftArrow && rightArrow ? { navigation: { prevEl: leftArrow, nextEl: rightArrow } } : {}),
  };
  var swiper;

  const handleSwiper = throttle(() => {
    if (swiper?.destroy) swiper.destroy(true, true);
    swiper = new Swiper(sliderWrapper, {
      ...options,
      slidesPerView: getCssVariable(snippetContainer, '--slides'),
      spaceBetween: getCssVariable(snippetContainer, '--gap'),
    });
  }, 300);

  handleSwiper();
  window.addEventListener('resize', handleSwiper);
};

execOnLoad(window.dAgency.initCarousel, '.carousel__container');
